import { mapGetters } from 'vuex'
import { isDisplayScreen } from '@mixins/reloads-on-publish'

export const LOAD_RETRY_MS = 30 * 1000

// Nobody is at a display screen to press reload, so a load that failed tries
// again until it works
export default {
  data() {
    return {
      loadRetryTimeout: null,
      isLoadRetryStopped: false,
    }
  },
  computed: {
    ...mapGetters('layoutEditor', ['isShowingLayoutEditUI']),
    ...mapGetters('editor', ['isShowingEditUI']),
  },
  beforeDestroy() {
    // A load still in flight can fail after this, and its retry would load
    // data for a page that's gone
    this.isLoadRetryStopped = true
    clearTimeout(this.loadRetryTimeout)
  },
  methods: {
    retryLoadOnDisplay(load) {
      if (this.isLoadRetryStopped) return
      clearTimeout(this.loadRetryTimeout)
      this.loadRetryTimeout = setTimeout(() => {
        // Decided when the timer fires, since a load can fail before the
        // route has resolved
        const isOnDisplay = isDisplayScreen({
          routeName: this.$route.name,
          isShowingLayoutEditUI: this.isShowingLayoutEditUI,
          isShowingEditUI: this.isShowingEditUI,
        })
        if (isOnDisplay) load()
        else this.retryLoadOnDisplay(load)
      }, LOAD_RETRY_MS)
    },
  },
}
